import { Divider } from '@/components/ui/divider';
import { Skeleton, SkeletonText } from '@/components/ui/skeleton';
import { VStack } from '@/components/ui/vstack';

/**
 * Placeholder for a profile's bio sections while they load.
 *
 * The header above it draws immediately from what the caller already holds, so
 * a reader sees who the profile belongs to and then watches the body arrive.
 * Without this the panel sat empty under a filled header, which read as a
 * profile with nothing in it rather than one still loading.
 *
 * Shaped as a few titled blocks rather than the real sections, since which ones
 * a given expert has is exactly what has not loaded yet.
 */
export function ProfileSectionsSkeleton() {
  return (
    <VStack className="px-5 pt-6" space="xl">
      {[0, 1, 2].map((section) => (
        <VStack key={section} space="md">
          {section === 0 ? null : <Divider className="mb-2" />}

          <Skeleton variant="rounded" className="h-4 w-1/3" />

          <VStack space="sm">
            <SkeletonText _lines={3} gap={2} className="h-3" />
          </VStack>
        </VStack>
      ))}
    </VStack>
  );
}
